import React from "react";

export const LoadingSkeleton: React.FC = () => {
  return (
    <div data-testid="loading-skeleton" className="space-y-6">
      {/* Summary Cards Skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="bg-white rounded-lg border border-neutral-200 p-6">
            <div className="h-4 bg-neutral-200 rounded w-1/2 mb-4 animate-pulse"></div>
            <div className="h-8 bg-neutral-200 rounded w-3/4 animate-pulse"></div>
          </div>
        ))}
      </div>

      {/* Chart Skeleton */}
      <div className="bg-white rounded-lg border border-neutral-200 p-6">
        <div className="h-6 bg-neutral-200 rounded w-1/4 mb-4 animate-pulse"></div>
        <div className="h-48 bg-neutral-100 rounded animate-pulse"></div>
      </div>

      {/* Breakdown Skeleton */}
      <div className="bg-white rounded-lg border border-neutral-200 p-6">
        <div className="h-6 bg-neutral-200 rounded w-1/3 mb-4 animate-pulse"></div>
        <div className="space-y-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-12 bg-neutral-100 rounded animate-pulse"></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoadingSkeleton;
